import { fetchGetCustomerNameByInn } from '../../../repositories/billing-accounts/v1/get-customer-name-by-inn';

import { mappers } from './mappers';
import {
  EGetCustomerNameByInnStatus,
  IGetCustomerNameByInnDependencies,
  IGetCustomerNameByInnResult,
  IGetCustomerNameByInnParamters,
} from './types';

export const getCustomerNameByInn = async (
  dependencies: IGetCustomerNameByInnDependencies,
  parameters: IGetCustomerNameByInnParamters,
): Promise<IGetCustomerNameByInnResult> => {
  const { httpApi, logger } = dependencies;

  try {
    return (await fetchGetCustomerNameByInn<IGetCustomerNameByInnResult, IGetCustomerNameByInnResult>({
      httpApi,
      parameters,
      mappers,
    })) as IGetCustomerNameByInnResult;
  } catch (error) {
    logger.error(error, {
      degradation: 'Запрашивалось название компании по ИНН',
      description: 'billing-account /v1/get-customer-name-by-inn/ rejection error',
      requestParameters: JSON.stringify(parameters),
    });

    return {
      name: null,
      message: 'billing-account /v1/get-customer-name-by-inn/ rejection error',
      status: EGetCustomerNameByInnStatus.CriticalError,
    };
  }
};
